import script from "./BasicDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicDetails.vue?vue&type=script&setup=true&lang=ts"

import "./BasicDetails.vue?vue&type=style&index=0&id=acfe85a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acfe85a2"]])

export default __exports__